import { render, staticRenderFns } from "./SavedListGrid.vue?vue&type=template&id=2d20d6ff&"
import script from "./SavedListGrid.vue?vue&type=script&lang=js&"
export * from "./SavedListGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports